import axios from 'axios';



export const getAccounts = async (token) => {
    try {
         
        const response = await axios.get(`${process.env.REACT_APP_API_URL}dashbord/allUser`, {
            headers: {
                Authorization: token,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error:', error);
    }
}